import { SET_ACTIVE_ANNOUNCEMENT } from "../actions/actionTypes";

const announcementReducer = (state = null, action) => {
  switch (action.type) {
    case SET_ACTIVE_ANNOUNCEMENT:
      return action.payload;
    default:
      return state;
  }
};

export default announcementReducer;
